import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const AllPatientsPageStyled = styled(Box)(({ theme }) => ({
  ".page-title": {
    fontWeight: 600,
    color: theme.palette.text?.primary || "#111827",
    fontSize: "32px",
    lineHeight: "40px",
  },

  ".content-header": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "30px",
    marginTop: "6px",
  },

  ".filters-container": {
    display: "flex",
    alignItems: "flex-end",
    gap: "16px",
  },

  ".table-container": {
    borderRadius: "12px",
    overflow: "hidden",
    boxShadow: "none",
  },

  ".table-header": {
    backgroundColor: theme.palette.background?.secondary || "#FFFFFF",
    fontWeight: 600,
    color: theme.palette.text?.primary || "#111827",
    fontSize: "14px",
    lineHeight: "20px",
    padding: "16px",
    borderBottom: `1px solid ${theme.palette.border?.medium || "#E5E7EB"}`,
  },

  ".table-row": {
    "&:hover": {
      backgroundColor: theme.palette.action?.hover || "rgba(0, 0, 0, 0.04)",
    },
    "&:not(:last-child)": {
      borderBottom: `1px solid ${theme.palette.border?.light || "#F3F4F6"}`,
    },
  },

  ".table-cell": {
    padding: "16px",
    fontSize: "14px",
    lineHeight: "20px",
    color: theme.palette.text?.primary || "#111827",
  },

  ".patient-name-cell": {
    padding: "16px",
    fontSize: "14px",
    lineHeight: "20px",
  },
}));
